import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "19",
  fill: "none",
  viewBox: "0 0 16 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      r: "4",
      stroke: "#D7207C",
      "stroke-width": "1.5",
      transform: "matrix(-1 0 0 1 8 5)"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#D7207C",
      "stroke-width": "1.5",
      d: "M1 14.935c0-.86.54-1.628 1.351-1.918a16.8 16.8 0 0 1 11.298 0A2.04 2.04 0 0 1 15 14.936v1.315c0 1.188-1.052 2.1-2.227 1.932l-.955-.136a27 27 0 0 0-7.636 0l-.955.136A1.95 1.95 0 0 1 1 16.25z"
    }, null, -1)
  ]))]))
}
export default { render: render }